import './appointment.scss';
import './add-event.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSAddEvent } from './add-event';

components.register({
  selector: '.sc-AddEvent',
  controller: GSAddEvent
});
